import { useCallback } from 'react'

type InputFormProps = {
  schema: string
  uiSchema: string
  formData: string
}

type ConvertReturnProps = {
  schema: object | null
  uiSchema: object | null
  formData: object | null
}

const useConvertForm = () => {
  const convertForm = useCallback(
    (form: InputFormProps | undefined): ConvertReturnProps => {
      if (!form) {
        return {
          schema: null,
          uiSchema: null,
          formData: null,
        }
      }

      const {
        schema: rawSchema,
        uiSchema: rawUiSchema,
        formData: rawFormData,
      } = form

      try {
        const schema = JSON.parse(rawSchema)
        const uiSchema = JSON.parse(rawUiSchema)
        const formData = JSON.parse(rawFormData)

        return {
          schema,
          uiSchema,
          formData: Array.isArray(formData) ? {} : formData,
        }
      } catch {
        return {
          schema: null,
          uiSchema: null,
          formData: null,
        }
      }
    },
    []
  )

  return {
    convertForm,
  }
}

export default useConvertForm
